<template>
  <v-dialog
    v-model="dialog"
    scrollable
    max-width="600px"
    :fullscreen="this.$vuetify.breakpoint.xsOnly"
  >
    <ConfirmBeforeCancel
      :dialog="confirmBeforeCancelDialog"
      @dialogClosed="dialogClosed"
      @confirmBetCancel="confirmBetCancel"
    />

    <v-card>
      <v-toolbar max-height="64">
        <v-toolbar-title>{{ $t("bet") }}</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn icon @click="dialog = false">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-toolbar>

      <v-card-text style="height: auto" class="pa-2 white">
        <BetCard />
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions v-if="confirmCancel" class="pa-4">
        <v-spacer></v-spacer>
        <span class="mr-2">
          {{ payBet ? $t('wantPaidBet') : $t("wantCancelTheBet") }} 
          <b>{{ betData.id }}</b>?
        </span>
        <v-btn
          depressed
          @click="beforeCancelBet(), (disabledCancel = true)"
          color="info"
          :disabled="disabledCancel"
        >
          {{ $t("yes") }} &nbsp;
        </v-btn>

        <v-btn
          depressed
          @click="confirmCancel = false"
          class="white black--text"
        >
          {{ $t("no") }} &nbsp;
        </v-btn>
      </v-card-actions>
      <v-card-actions
        v-else
        class="pa-4 d-flex"
        :class="$vuetify.breakpoint.width < 350 ? 'flex-column align-end' : ''"
      >
        <v-spacer></v-spacer>
        <!-- <v-btn text @click="dialog = false">Fechar</v-btn> -->

        <v-btn
          v-if="showCancelBetButton"
          depressed
          @click="confirmCancel = true"
          :disabled="disabledCancel"
          :color="payBet ? 'green' : 'purple'"
        >
          <v-icon left class="ml-2">{{ payBet ? 'mdi-cash' : 'mdi-cancel' }}</v-icon>
          {{ payBet ? $t("paidBet") : $t("cancelBet") }} &nbsp;
        </v-btn>

        <v-btn
          depressed
          @click="printOrSavePdf($vuetify.breakpoint.mobile, betData.id)"
          class="white black--text d-print-none py-0"
          :class="$vuetify.breakpoint.width < 350 ? 'mt-1' : ''"
        >
          <v-icon left class="ml-2">
            {{ $vuetify.breakpoint.mobile ? "mdi-download" : "mdi-printer" }}
          </v-icon>
          {{ $vuetify.breakpoint.mobile ? $t("savePdf") : $t("print") }} &nbsp;
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
import BetCard from "@/components/common/bet/BetCard";
import ConfirmBeforeCancel from "./ConfirmBeforeCancel.vue";
export default {
  name: "bet-dialog",
  components: {
    BetCard,
    ConfirmBeforeCancel,
  },
  data: () => ({
    dialog: false,
    disabledCancel: false,
    showCancelBetButton: false,
    level: "",
    confirmCancel: false,
    isBetPaidOrCashout: false,
    confirmBeforeCancelDialog: false,
  }),
  created() {
    if (this.betData) {
      this.isBetPaidOrCashout =
        (this.betData.result_bet == "1" || this.betData.result_bet == "2") &&
        this.betData.status_bet == "1" &&
        this.betData.paid == "1" &&
        (this.betData.debita_saldo == "2" || this.betData.debita_saldo == "3");
    }
  },
  computed: {
    betDialog() {
      return this.$store.state.betDialog;
    },
    betData() {
      return this.$store.state.betCard.betData;
    },
    // Para verificar qual deve imprimir (Aposta Online ou de Terminal)
    agent() {
      return this.$store.state.betCard.agentData;
    },
    // Para verificar qual deve imprimir (Aposta Online ou de Terminal)
    player() {
      return this.$store.state.betCard.playerData;
    },
    payBet() {
      return this.$store.state.payBet;
    }
  },
  watch: {
    betDialog() {
      this.level = this.$localStorage.getItem("level", "string");
      if (this.level == "regionalManager") {
        this.showCancelBetButton =
          this.betData.result_bet == "" && this.betData.status_bet == "1";
      }

      if (this.level == "administrator") {
        this.showCancelBetButton = this.betData.status_bet == "1";
      }

      if (this.level == "collaborator") {
        const canCancelBet = this.$permission("9");

        if (canCancelBet) {
          this.showCancelBetButton = this.betData.status_bet == "1";
        } else {
          this.showCancelBetButton = false;
        }
      }

      this.dialog = true;
    },
    dialog() {
      this.$store.commit("showBetDialog", false);
      this.disabledCancel = false;
      this.confirmCancel = false;
    },
    betData(bet) {
      if (bet) {
        this.isBetPaidOrCashout =
          (bet.result_bet == "1" || bet.result_bet == "2") &&
          bet.status_bet == "1" &&
          bet.paid == "1" &&
          (bet.debita_saldo == "2" || bet.debita_saldo == "3");
      }
    },
  },
  methods: {
    printOrSavePdf(pdf, bet_id) {
      if (pdf) {
        this.$saveBetAsPdf(bet_id);
      } else {
        this.printBet();
      }
    },
    printBet: async function() {
      if (this.agent) {
        await this.$bet.getBetAgent(this.betData.id, 1);
      }
      if (this.player) {
        await this.$bet.getBetPlayer(this.betData.id);
      }
      this.$printBet();
    },
    paidBet: async function() {
      const endpoint = `administrator/bets/paidbet`;
      const id_bet = this.betData.id;
      const request = await this.$request.post(endpoint, { id_bet });

      if (request.length == 0) return;

      this.dialog = false;
      this.$store.commit("setRefresh", true);
      this.$store.commit("setFeedbackDialog", {
        title: this.$t("betCod") + id_bet,
        msg: request.dados,
        type: "success",
        action: "",
      });
    },

    cancelBet: async function() {
      // const { nivel } = JSON.parse(localStorage.user_data);
      // const endPoints = {
      //   3: "localManager/bets/cancelBet",
      //   4: "regionalManager/bets/cancelBet",
      //   6: "administrator/bets/cancelBet",
      // };

      const level = this.level == "collaborator" ? "colab" : this.level;

      const endpoint = `${level}/bets/cancelBet`;
      const id_bet = this.betData.id;
      const request = await this.$request.post(endpoint, { id_bet });

      if (request.length == 0) return;

      this.dialog = false;
      this.$store.commit("setRefresh", true);
      this.$store.commit("setFeedbackDialog", {
        title: "Aposta cod. " + id_bet + " cancelada",
        msg: request.messages,
        type: "success",
        action: "",
      });
    },
    beforeCancelBet() {
      if (this.isBetPaidOrCashout) {
        this.confirmBeforeCancelDialog = true;
      } else {
        if (this.payBet) {
          this.paidBet();
        } else {
          this.cancelBet();
        }
      }
    },
    dialogClosed() {
      this.confirmBeforeCancelDialog = false;
      this.disabledCancel = false;
    },
    confirmBetCancel() {
      this.cancelBet();
    },
  },
};
</script>
